import { get } from 'lodash';

export type PatientFormTemplateRedirectType = 'goToForm' | 'scheduler' | 'goTo' | 'isFinal' | 'externalUrl';
export type PatientFormTemplateRedirectTypeJumpLogicV2 = 'form' | 'web-scheduler' | 'question' | 'url';

export type TJumpLogicV2DetailsOptions = {
  scheduler?: {
    showZipcodeFilter: boolean;
    zipcodeMaxDistance: number;
    allowResourcesSearching: boolean;
    showFilters: boolean;
    hideCalendar: boolean;
    practiceResourceFilters: {
      provider: string[];
      facility: string[];
      apptType: string[];
    };
  };
};

export interface IJumpLogicV2Response {
  redirect: {
    type: PatientFormTemplateRedirectTypeJumpLogicV2;
    options?: TJumpLogicV2DetailsOptions;
    value?: string;
  };
}

interface IParams {
  hideCalendar: boolean;
  showFilters: boolean;
  allowResourcesSearching: boolean;
  showZipcodeFilter: boolean;
  zipcodeMaxDistance: string | number;
  facility: string[];
  provider: string[];
  appointmentType: string[];
}

const getUrlToGo = (urlValue: string) => {
  const isExternalURL = urlValue.startsWith('http://') || urlValue.startsWith('https://');
  const urlOrigin = window.location.origin;
  const urlToGo = isExternalURL ? urlValue : `${urlOrigin}/${urlValue}`;
  return urlToGo;
};

const getFiltersParamsForAvailabilities = (redirectOptions: TJumpLogicV2DetailsOptions | undefined): IParams => {
  const practiceResourceFilters = redirectOptions?.scheduler?.practiceResourceFilters;
  const filtersParams = {
    hideCalendar: !!get(redirectOptions, 'scheduler.hideCalendar', false),
    showFilters: !!get(redirectOptions, 'scheduler.showFilters', false),
    allowResourcesSearching: !!get(redirectOptions, 'scheduler.allowResourcesSearching', true),
    showZipcodeFilter: !!get(redirectOptions, 'scheduler.showZipcodeFilter', false),
    zipcodeMaxDistance: get(redirectOptions, 'scheduler.showZipcodeFilter', false)
      ? get(redirectOptions, 'scheduler.zipcodeMaxDistance', '')
      : '',
    facility: practiceResourceFilters?.facility ?? [],
    provider: practiceResourceFilters?.provider ?? [],
    appointmentType: practiceResourceFilters?.apptType ?? [],
  };

  return filtersParams;
};

interface INormalizedRedirectValues {
  type: PatientFormTemplateRedirectType;
  value?: string;
  params?: IParams;
}

const normalizeJumpLogicV2Response = (logicV2Request: IJumpLogicV2Response): INormalizedRedirectValues | null => {
  const redirectType = logicV2Request.redirect.type;

  if (redirectType === 'form') {
    return {
      type: 'goToForm',
      value: logicV2Request.redirect.value,
    };
  }

  if (redirectType === 'web-scheduler') {
    const redirectOptions = logicV2Request.redirect.options;
    const filtersParams = getFiltersParamsForAvailabilities(redirectOptions);

    return {
      type: 'scheduler',
      params: filtersParams,
      value: logicV2Request.redirect.value,
    };
  }

  if (redirectType === 'question') {
    return { type: 'goTo', value: logicV2Request.redirect.value };
  }

  // if (redirectType === 'isFinal') {
  //   // TODO rrigoni
  //   return { type: 'isFinal' };
  // }

  if (redirectType === 'url') {
    return { type: 'externalUrl', value: getUrlToGo(String(logicV2Request.redirect.value)) };
  }

  return null;
};

export default normalizeJumpLogicV2Response;
